import { AuthenticationService } from './../../../core/services/auth.service';
import { EmployeesService } from './../../../view/employees/services/employees.service';
import { DepartmentsService } from './../../../view/departments/services/departments.service';
import { NgbModal, NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { ServicesService } from "./../../../pages/services/services.service";
import {
  Component,
  Input,
  OnChanges,
  OnInit,
  SimpleChanges,
  AfterViewInit,
} from "@angular/core";
import { FormBuilder, FormGroup } from "@angular/forms";
import { TranslateService } from "@ngx-translate/core";
import { IconsService } from "app/shared/services/Modal/icons.service";

@Component({
  selector: "app-statistics",
  templateUrl: "./statistics.component.html",
  styleUrls: ["./statistics.component.css"],
})
export class StatisticsComponent implements OnInit, AfterViewInit, OnChanges {
  @Input() employeeId: number;
  filterForm:FormGroup
  lang: string = "ar";
  statistics: any = [];
  filter = [
    { name: "Week", value: "w" },
    { name: "month", value: "m" },
    {name:"custom",value:null}
  ];
  filterId: string = "";
  allUserCompanies:any[]=[]
  listOfDepartment:any[]=[]
  Emps:any[]=[]
  constructor(
    public iconService: IconsService,
    private ServicesService: ServicesService,
    private translateServ: TranslateService,
    private _fb:FormBuilder,
    public _NgbModal:NgbModal,
    private _DepartmentsService:DepartmentsService,
    private _EmployeesService:EmployeesService,
    private _NgbActiveModal:NgbActiveModal,
    public _AuthenticationService:AuthenticationService
  ) {
    this.lang = translateServ.currentLang;
    this.filterForm= _fb.group({
      timeRange:[null],
      departmentId:[null],
      companyId:[null],
      employeeId:[null],
      startDate:[null],
      endDate:[null]
    })
    this.filterForm.get('timeRange').patchValue('w')
    this.ServicesService.getUserCompanies().subscribe({
      next: (res: any) => {
        this.allUserCompanies = res.data;
        this.filterForm.get('companyId').patchValue(this.allUserCompanies[0]?.id||null)
        this.getListOfDepartment()
      }
      })
  }
  statisticTitles = [
    { name: "totalTasks", value: "REQUESTS.totalTasks", bg: "#FEDDC7" },
    { name: "toDo", value: "REQUESTS.toDo", bg: "#BDDBFF" },
    { name: "inProgress", value: "REQUESTS.inprogress", bg: "#FDB6004D" },
    { name: "inReview", value: "REQUESTS.inReview", bg: "#EE2F8A4D" },
    { name: "done", value: "REQUESTS.done", bg: "#CEFAEB" },
    { name: "inTime", value: "REQUESTS.inTime", bg: "#61C36E4D" },
    { name: "late", value: "REQUESTS.late", bg: "#FF4E4233" },
    { name: "percentage", value: "FINANCES.percentage", bg: "#9872E64D" },
  ];

  customOptions: any = {
    loop: false,
    mouseDrag: true,
    touchDrag: true,
    pullDrag: false,
    dots: false,
    navSpeed: 700,
    navText: ["", ""],
    responsive: {
      0: {
        items: 1,
      },
      400: {
        items: 3,
      },
      740: {
        items: 6,
      },
      940: {
        items: 7,
      },
    },
    nav: true,
    rtl:this.lang== "ar" ? true : false
  };

  ngOnInit(): void {}

  ngAfterViewInit(): void {
    this.getStatistics();
  }
  ngOnChanges(changes: SimpleChanges): void {
    if (changes.employeeId?.currentValue) {
      this.getStatistics();
    }
  }
  getListOfEmps(){
    let req={
      CompanyId:this.filterForm.get('companyId').value,
      DepartmentId:this.filterForm.get('departmentId').value
    }
    this._EmployeesService.ListOfEmployees(req).subscribe(res=>{
      this.Emps = res.data;
    })
  }
 getListOfDepartment(companyId?:number): void {
    this.filterForm.patchValue({DepartmentId: null, JobId: null})

      this._DepartmentsService.ListOfDepartment(this.filterForm.get('companyId').value).subscribe({
        next: (res: any) => {

          this.listOfDepartment = res.data;
        }
      })
  }
  getStatistics() {
    this.ServicesService.getEmployeeTasksSummary(this.filterForm.value).subscribe(
      (res) => {
        this.statistics = res.data;
        this._NgbModal.dismissAll()
      }
    );
  }
  openFilter(item:any){
    this._NgbModal.open(item,{
      centered:true,
      size:'lg'
    })
  }
  onSubmit(){
    this.getStatistics()
  }
  rangeChanged(){
    if(this.filterForm.get('timeRange').value!=null){
      this.filterForm.get('startDate').patchValue(null)
      this.filterForm.get('endDate').patchValue(null)

    }
  }
}
